// src/constants/routes.js
export const ROUTES = {
  LOGIN: '/login',
  HOME: '/',
  CHAT_SESSIONS: '/chat-sessions',
  STARLIGHT: '/star-light',
  CHAT: '/chat',
  ACCOUNT: '/account'
};
